export default "__VITE_ASSET__DP62RGj5__"